import jump from '../../vendor/jump';
import bp from '../../utilities/breakpoints';

function init() {
  const html = document.querySelector('html');
  const nav = document.querySelector('#navigation-external');

  if (!nav) {
    return;
  }

  const parents = nav.querySelectorAll('.menu-item-has-children');

  if (!parents) {
    return;
  }

  Array.from(parents).forEach((parent) => {
    const anchor = parent.firstChild;

    if (!anchor) {
      return;
    }

    anchor.addEventListener('click', (e) => {
      e.preventDefault();
      const li = anchor.parentElement;
      const sub = li.querySelector('.sub-menu');

      if (!li || !sub) {
        return;
      }

      const { height } = sub.getBoundingClientRect();

      if (html.classList.contains('is-external-open')) {
        close();
      } else {
        html.classList.add('is-external-open');

        if (!bp.is('medium')) {
          li.style.height = `${height + li.clientHeight}px`;
          window.setTimeout(() => {
            jump(li, {
              container: '#header-panel',
              duration: 500
            });
          }, 500);
        } else {
          li.removeAttribute('style');
        }
      }
    });
  });
}

function close() {
  const html = document.querySelector('html');
  const nav = document.querySelector('#navigation-external');

  if (!nav) {
    return;
  }

  const lis = nav.querySelectorAll('li');

  html.classList.remove('is-external-open');

  Array.from(lis).forEach((li) => {
    li.removeAttribute('style');
  });
}

export { init, close };
